import React from 'react';
import TextField from '../audi-ui-components/TextField';
import IconCalendar from '../audi-ui-components/icons/CalendarEvents';
import DatePicker from 'react-datepicker';

class DateFieldInput extends React.Component {

    handleChange = (v,e) => {
        this.props.onChange(e);
    }

    render() {
        return (
            <TextField
                {...this.props}
                icon={<IconCalendar size="small" />}
                onChange={this.handleChange}
            />
        );
    }
}

class DateField extends React.Component {

    render() {
        var d = this.props.value;
        if (!(d instanceof Date && !isNaN(d))) {
            d = "";
        }
        const { minDate, maxDate, onChange, className, ...rest} = this.props
        return (
          <div className={className}>
            <DatePicker
                selected={d}
                dateFormat="dd/MM/yyyy"
                minDate={minDate}
                maxDate={maxDate}
                onChange={onChange}
                customInput={<DateFieldInput {...rest} />}
            />
          </div>
        );
    }
}

export default DateField;
